'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dateToDateString = require('./dateToDateString');

var _dateToDateString2 = _interopRequireDefault(_dateToDateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	var d = new Date();
	d.setFullYear(new Date().getFullYear() + 1);
	return (0, _dateToDateString2.default)(d);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/oneYearAfterStr.js
// module id = 68
// module chunks = 0